export const genreIconMap: Record<string, string> = {
  热血: "ri-fire-line",
  恋爱: "ri-heart-line",
  冒险: "ri-compass-3-line",
  奇幻: "ri-magic-line",
  校园: "ri-graduation-cap-line",
  科幻: "ri-planet-line",
  悬疑: "ri-question-line",
  治愈: "ri-leaf-line",
  日常: "ri-sun-line",
  竞技: "ri-trophy-line",
  美食: "ri-restaurant-2-line",
  古风: "ri-ancient-gate-line",
  武侠: "ri-sword-line",
  机战: "ri-robot-2-line",
  运动: "ri-basketball-line",
  音乐: "ri-music-2-line",
  推理: "ri-search-eye-line",
  战斗: "ri-sword-line",
  心理: "ri-brain-line",
  青春: "ri-riding-line",
  文艺: "ri-book-open-line",
  惊悚: "ri-ghost-line",
  剧情: "ri-film-line",
  喜剧: "ri-emotion-happy-line",
};

export const getGenreIcon = (genre: string): string => genreIconMap[genre] ?? "ri-price-tag-3-line";